<div style="font-size: large">
  <ng-container *ngIf="data?.status === 0">Leider konnte keine Verbindung zum Server aufgebaut werden. Bitte prüfen Sie, ob Ihr Gerät mit dem Internet verbunden ist und versuchen Sie es erneut.</ng-container>
  <ng-container *ngIf="data?.status !== 0">Es ist leider ein Fehler aufgetreten. Bitte versuchen Sie, die Seite neu zu laden oder schicken Sie uns einen Fehlerbericht.</ng-container>
</div>
<br/>
<div class="w-100 text-right">
  <button mat-flat-button (click)="reload()">Seite neu laden</button>
  &nbsp;
  <a [href]="getErrorMailUrl()" *ngIf="data?.status !== 0">
    <button mat-flat-button color="primary">Fehlerbericht senden</button>
  </a>
</div>
